export function translateEvent(eventName, messages = {}) {
   if (!eventName || typeof eventName !== "string") return eventName;

    const partTwoTransform = eventName.toLowerCase().replace(/\s+/g, "_");
    const translation = messages[`event_${partTwoTransform}`];

    return translation || eventName;
}

/**
 * Map "Input X On/Off" event names to custom labels from unitInputs API.
 * Format: "LabelTitle: On" or "LabelTitle: Off"
 * e.g. "Input 1 On" → "PTO Engaged: On", "Input 3 Off" → "SC 2: Off"
 *
 * Uses the catalog `title` field for the display name.
 * Falls back to extracting from onLabel/offLabel if title is not available.
 *
 * @param {string} eventName - Original event name
 * @param {Array} unitInputs - Array from searchUnitInputs API [{position, onLabel, offLabel, title, ...}]
 * @returns {string} Custom label or original eventName if no match
 */
export const mapInputEventName = (eventName, unitInputs) => {
  if (!eventName || !unitInputs || unitInputs.length === 0) return eventName;

  const inputMatch = eventName.match(/^Input\s*(\d+)\s*(On|Off)$/i);
  if (!inputMatch) return eventName;

  const position = parseInt(inputMatch[1], 10);
  const state = inputMatch[2].toLowerCase(); // 'on' or 'off'

  const unitInput = unitInputs.find(input => input.position === position);
  if (!unitInput) return eventName;

  // Prefer catalog title (e.g., "PTO Engaged"), fall back to extracting from onLabel/offLabel
  let labelName = unitInput.title;

  if (!labelName) {
    const customLabel = state === 'on' ? unitInput.onLabel : unitInput.offLabel;
    if (!customLabel) return eventName;
    labelName = customLabel.replace(/\s*(ON|OFF)$/i, '').trim();
  }

  if (!labelName) return eventName;

  // Format: "LabelName: On" or "LabelName: Off"
  return `${labelName}: ${state === 'on' ? 'On' : 'Off'}`;
};
